import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=2ee84390&scoped=true&"
import script from "./Cards.vue?vue&type=script&lang=ts&"
export * from "./Cards.vue?vue&type=script&lang=ts&"
import style0 from "./Cards.vue?vue&type=style&index=0&id=2ee84390&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee84390",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TitleDescription: require('/var/www/components/TitleDescription.vue').default})
